module.exports = __webpack_public_path__ + "img/share-qzone.76920868.png";